/* 🤖 this file was generated by script */
export const wsolidiconStickerCircle = {
  name: 'sticker_circle',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M11.78 1C7.43 1 3.05 3.79 1.45 7.89c-.14.37-.22.56-.17.72a.5.5 0 0 0 .25.31c.15.08.38.04.85-.03a11.12 11.12 0 0 1 12.76 12.53c-.07.49-.1.73-.02.88a.5.5 0 0 0 .33.25c.16.03.35-.05.74-.22A11.12 11.12 0 0 0 11.78 1"/><path fill="currentColor" d="M11.94 21.4c.3.3.46.45.63.47q.23.02.4-.14c.13-.12.16-.32.2-.7q.08-.58.08-1.16a9.12 9.12 0 0 0-10.28-9.05c-.39.05-.59.08-.7.2-.1.1-.16.27-.15.41.02.17.18.32.48.63z"/></svg>`,
  iconStyle: 'solid',
};
